// client/src/components/HeroSection.js
import { VStack, Image, Text } from "@chakra-ui/react";


export default function HeroSection() {
    return (
        <VStack 
            spacing={{ base: "14px", md: "clamp(16px, 1.2vw, 28px)" }}
            textAlign="center"
            align="center"
            my={{ base: "auto", md: "clamp(32px, 2.5vw, 50px)" }}
            w="100%"
        >
            <Image
                src="/icon_hero.svg"
                alt="Engineering Assistant"
                width={{ base: "120px", md: "clamp(175px, 12vw, 220px)" }} 
                borderRadius="100px"
            />

            <Text 
                fontSize={{ base: "22px", sm: "26px", md: "clamp(28px, 2.5vw, 48px)" }} 
                fontWeight="bold" 
                width={{ base: "100%", md: "clamp(65%, 65%, 65%)" }}
                px={{ base: 2, md: 0 }}
                lineHeight="1.2" 
            >
                Analyze, optimize, prepare your design for fabrication
            </Text>

            <Text
                fontSize={{ base: "13px", sm: "14px", md: "clamp(14px, 1.1vw, 20px)" }} 
                fontWeight="medium"
                width={{ base: "100%", md: "clamp(80%, 80%, 85%)" }} 
                px={{ base: 2, md: 0 }}
                color="#6D6D6D"
                lineHeight="1.6"
            >
                Alpherra analyzes geometry, materials, tolerances, and feasibility
                risks, giving you actionable suggestions for safer, stronger,
                production-ready designs.
            </Text>
        </VStack>
    );
}
